import { render, staticRenderFns } from "./byssyxx.vue?vue&type=template&id=32ad254e&scoped=true"
import script from "./byssyxx.vue?vue&type=script&lang=js"
export * from "./byssyxx.vue?vue&type=script&lang=js"
import style0 from "./byssyxx.vue?vue&type=style&index=0&id=32ad254e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ad254e",
  null
  
)

export default component.exports